import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "label", "chevronClosed", "chevronOpen"]

  toggle(event) {
    const checked = event.target.checked

    this.detailsTarget.classList.toggle("d-none", !checked)
    this.element.classList.toggle("dashed-box", !checked)
    this.element.classList.toggle("shadow-sm", checked)
    this.labelTarget.classList.toggle("text-muted", !checked)
    this.chevronClosedTarget.classList.toggle("d-none", checked)
    this.chevronOpenTarget.classList.toggle("d-none", !checked)
  }
}
